import { faArrowUpArrowDown } from '@fortawesome/pro-regular-svg-icons/faArrowUpArrowDown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ActionIcon, Menu } from '@mantine/core';
import { FormattedMessage, useIntl } from 'react-intl';

import { rateSortMenuMessages } from './rate-sort-menu-messages';
import { RATE_SORT_OPTION } from './rate-sorting';
import styles from './RateSortMenu.module.css';

import type { RateSortOption } from './rate-sorting';

type RateSortMenuProps = {
  sortOption: RateSortOption;
  onSortOptionChange: (next: RateSortOption) => void;
  onTriggerInteract?: () => void;
  zIndex?: number;
};

const SORT_MENU_ITEMS = [
  { option: RATE_SORT_OPTION.PriceAscending, message: rateSortMenuMessages.priceAscending },
  { option: RATE_SORT_OPTION.PriceDescending, message: rateSortMenuMessages.priceDescending },
  { option: RATE_SORT_OPTION.TransitAscending, message: rateSortMenuMessages.transitAscending },
  { option: RATE_SORT_OPTION.TransitDescending, message: rateSortMenuMessages.transitDescending },
] as const;

export const RateSortMenu = ({ sortOption, onSortOptionChange, onTriggerInteract, zIndex }: RateSortMenuProps) => {
  const intl = useIntl();

  return (
    <Menu position='bottom-end' zIndex={zIndex}>
      <Menu.Target>
        <ActionIcon
          aria-label={intl.formatMessage(rateSortMenuMessages.sortAriaLabel)}
          className={styles.sortTrigger}
          data-testid='rate-sort-menu-target'
          onClick={onTriggerInteract}
          variant='ghost'
        >
          <FontAwesomeIcon icon={faArrowUpArrowDown} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Label className={styles.sortLabel}>
          <FormattedMessage {...rateSortMenuMessages.sortByLabel} />
        </Menu.Label>
        {SORT_MENU_ITEMS.map(({ option, message }) => (
          <Menu.Item
            aria-checked={option === sortOption}
            className={styles.sortItem}
            data-selected={option === sortOption}
            data-testid={`rate-sort-option-${option}`}
            key={option}
            onClick={() => onSortOptionChange(option)}
          >
            <FormattedMessage {...message} />
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
};
